// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateBreederBindingManager, ValidateCreateBreederBindingManagerSchema } from 'api/gen/ValidateCreateBreederBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateBreederBindingManager, ValidateUpdateBreederBindingManagerSchema } from 'api/gen/ValidateUpdateBreederBindingManager';

export const ValidateBreederBindingManagerSchema = t.union([ValidateCreateBreederBindingManagerSchema, ValidateUpdateBreederBindingManagerSchema]);

export type ValidateBreederBindingManager = t.TypeOf<typeof ValidateBreederBindingManagerSchema>;
